import { Injectable } from '@angular/core';
import { fetchAuthSession, signInWithRedirect } from '@aws-amplify/auth';
import * as Auth from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthWrapper {
  async confirmSignUp(input: Auth.ConfirmSignUpInput): Promise<Auth.ConfirmSignUpOutput> {
    return await Auth.confirmSignUp(input);
  }

  async signIn(input: Auth.SignInInput): Promise<Auth.SignInOutput> {
    return await Auth.signIn(input);
  }

  async resendSignUpCode(input: Auth.ResendSignUpCodeInput): Promise<Auth.ResendSignUpCodeOutput> {
    return await Auth.resendSignUpCode(input);
  }

  async confirmResetPassword(input: Auth.ConfirmResetPasswordInput): Promise<void> {
    return await Auth.confirmResetPassword(input);
  }

  async signUp(input: Auth.SignUpInput): Promise<Auth.SignUpOutput> {
    return await Auth.signUp(input);
  }

  async resetPassword(input: Auth.ResetPasswordInput): Promise<Auth.ResetPasswordOutput> {
    return await Auth.resetPassword(input);
  }

  async getCurrentUser(): Promise<Auth.AuthUser> {
    return await Auth.getCurrentUser();
  }

  async getIdToken(): Promise<string | null> {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();
      return idToken ?? null;
    } catch {
      return null;
    }
  }

  async signOut(input?: Auth.SignOutInput): Promise<void> {
    return await Auth.signOut(input);
  }

  async signInWithAuth0Redirect(): Promise<void> {
    // Provider name must match the IdP name configured in Cognito (e.g., 'Auth0')
    // Use custom provider shape to satisfy typings
    return await signInWithRedirect({ provider: { custom: 'Auth0' } });
  }

  async signInWithLinkedInRedirect(): Promise<void> {
    // LinkedIn configured as a custom OIDC provider named 'LinkedIn' in Cognito
    return await signInWithRedirect({ provider: { custom: 'LinkedIn' } });
  }

  async signInWithGoogleRedirect(): Promise<void> {
    // Direct Google via Cognito Social IdP; force account chooser
    // Amplify expects AuthPrompt enum-like values: 'SELECT_ACCOUNT' | 'LOGIN' | 'CONSENT'
    return await signInWithRedirect({ provider: 'Google', options: { prompt: 'SELECT_ACCOUNT' } });
  }

  async signInWithMicrosoftRedirect(): Promise<void> {
    // Microsoft configured as a custom OIDC provider named 'Microsoft' in Cognito
    return await signInWithRedirect({ provider: { custom: 'Microsoft' } });
  }
}
